export default __webpack_public_path__ + "static/media/programming-language-preview-icon.75318314.svg";